module.exports = __webpack_public_path__ + "img/logo-large.c444cea9.svg";